
import React, { useState } from "react";
import Swal from 'sweetalert2';

import { restoreProduct } from "../generatedRequest/master";
import { toast } from "react-toastify";
interface Attribute {
    attributeName: string;
    value: string;
    unit: {
        _id: string;
        name: string;
    };
    _id: string;
}

interface ProductData {
    _id: string;
    modelNumber: string;
    displayName: string;
    isMasterchild: boolean;
    attributes: Attribute[];
}

const RemoveProduct = ({
    removedData,
    masterDataId,
    onRestoreSuccess
}: {
    removedData: ProductData[];
    masterDataId: string;
   onRestoreSuccess?: () => void;
}): JSX.Element => {

    // console.log(removedData, "remove");
    // console.log(masterDataId, "masterdataID")


    // State for selected products
    const [selectedProducts, setSelectedProducts] = useState<string[]>([]);
    const [isRestoring, setIsRestoring] = useState(false);

    const handleRestore = async () => {
    if (selectedProducts.length === 0) {
        Swal.fire({
            icon: 'warning',
            title: 'No Selection',
            text: 'Please select at least one product to restore',
            confirmButtonText: 'OK',
            confirmButtonColor: '#00A2F3',
        });
        return;
    }

    const result = await Swal.fire({
        title: 'Confirm Restore',
        text: `Are you sure you want to restore ${selectedProducts.length} product${selectedProducts.length > 1 ? 's' : ''}?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, Restore',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#00A2F3',
        cancelButtonColor: '#d33',
    });

    if (!result.isConfirmed) {
        return;
    }

    try {
        setIsRestoring(true);
        const response = await restoreProduct(masterDataId, selectedProducts);
        // console.log("Restore response:", response);
        if (onRestoreSuccess) {
            onRestoreSuccess();
        }
        // Swal.fire({
        //     icon: 'success',
        //     title: 'Success',
        //     text: `Successfully restored ${selectedProducts.length} product${selectedProducts.length > 1 ? 's' : ''}`,
        //     confirmButtonText: 'OK',
        //     confirmButtonColor: '#3085d6',
        // });
    } catch (error) {
        console.error("Error restoring products:", error);
        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to restore products. Please try again.',
            confirmButtonText: 'OK',
            confirmButtonColor: '#3085d6',
        });
    } finally {
        setIsRestoring(false);
    }
};
    // console.log(selectedProducts, "selectedProducts")
    // Get all unique attribute names from all products
    const getAllAttributeNames = (): string[] => {
        if (!removedData || removedData.length === 0) return [];

        const attributeNames = new Set<string>();
        removedData.forEach(product => {
            product.attributes.forEach(attr => {
                attributeNames.add(attr.attributeName);
            });
        });
        return Array.from(attributeNames);
    };

    
    const getAttributeValue = (product: ProductData, attributeName: string): string => {
        const attribute = product.attributes.find(attr =>
            attr.attributeName === attributeName
        );
        return attribute ? `${attribute.value}${attribute.unit?.name && attribute.unit.name !== 'Feature' ? ` ${attribute.unit.name}` : ''}` : '-';
    };

    const allAttributes = getAllAttributeNames();

    
    const isAllSelected = removedData && removedData.length > 0 &&
        selectedProducts.length === removedData.length;

   
    const isSomeSelected = selectedProducts.length > 0 &&
        selectedProducts.length < (removedData?.length || 0)
    
    const handleSelectAll = () => {
        let newSelection: string[] = [];
        if (isAllSelected) {
            // Deselect all
            newSelection = [];
        } else {
            // Select all
            newSelection = removedData?.map(product => product._id) || [];
        }
        setSelectedProducts(newSelection);
    };

   
    const handleProductSelect = (productId: string) => {
        const newSelection = selectedProducts.includes(productId)
            ? selectedProducts.filter(id => id !== productId)
            : [...selectedProducts, productId];

        setSelectedProducts(newSelection);
    };


    const isProductSelected = (productId: string): boolean => {
        return selectedProducts.includes(productId);
    };


    if (!removedData || removedData.length === 0) {
        return (
            <div className="card mt-5 mb-5" style={{ marginTop: "80px", position: "relative" }}>
                <div className="card-body text-center" style={{ padding: "40px" }}>
                    <i className="fas fa-box-open fa-3x text-muted mb-3"></i>
                    <h5 className="text-muted">No Removed Products</h5>
                    <p className="text-muted">There are no recently removed products to display.</p>
                </div>
            </div>
        );
    }

    const handleEditProduct = (productId: string | number) => {
        const url = process.env.REACT_APP_BASE_URL + `/product/edit?q=${productId}`;
        window.open(url, '_blank');
    };

    return (
        <div className="card mt-5 mb-5" style={{ marginTop: "80px", position: "relative" }}>
            <div className="card-header d-flex justify-content-between align-items-center">
                <h3 className="card-title align-items-start flex-column">
                    <span className="card-label fw-bold text-gray-900">Recently Updated Products</span>
                    <span className=" mt-1 text-muted fw-semibold fs-6">Products with recent data or attribute changes</span>
                </h3>
                <button
                    className="btn btn-primary"
                    type="button"
                    style={{ minWidth: "120px" }}
                    onClick={handleRestore}
                    disabled={selectedProducts.length === 0 || isRestoring}
                >
                    {isRestoring ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Restoring...
                        </>
                    ) : (
                        `Restore ${selectedProducts.length > 0 ? `(${selectedProducts.length})` : ''}`
                    )}
                </button>
            </div>
            <div className="card-body" style={{ padding: "10px" }}>
                <div
                    className="table-responsive"
                    style={{
                        overflowX: "auto",
                        overflowY: "hidden",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    <table
                        className="table table-bordered mb-0"
                        style={{
                            width: "100%",
                            minWidth: `${350 + (allAttributes.length * 180)}px`,
                            tableLayout: "fixed",
                            marginBottom: "0"
                        }}
                    >
                        <thead style={{ backgroundColor: "#f8f9fa" }}>
                            <tr>
                                <th
                                    style={{
                                        width: "50px",
                                        minWidth: "50px",
                                        maxWidth: "50px",
                                        fontWeight: "bold",
                                        padding: "12px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        position: "sticky",
                                        left: "0",
                                        backgroundColor: "#f8f9fa",
                                        zIndex: "10"
                                    }}
                                >
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        style={{ width: "18px", height: "18px" }}
                                        checked={isAllSelected}
                                        // ref={(input) => {
                                        //     if (input) {
                                        //         input.indeterminate = isSomeSelected;
                                        //     }
                                        // }}
                                        onChange={handleSelectAll}
                                        title={isAllSelected ? "Deselect All" : "Select All"}
                                    />
                                </th>
                                <th
                                    style={{
                                        width: "300px",
                                        minWidth: "300px",
                                        maxWidth: "300px",
                                        fontWeight: "bold",
                                        padding: "12px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        position: "sticky",
                                        left: "50px",
                                        backgroundColor: "#f8f9fa",
                                        zIndex: "10"
                                    }}
                                >
                                    Product Name
                                </th>
                                {allAttributes.map((attributeName, index) => (
                                    <th
                                        key={`header-${index}`}
                                        style={{
                                            width: "180px",
                                            minWidth: "180px",
                                            maxWidth: "180px",
                                            fontWeight: "bold",
                                            padding: "12px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        }}
                                        title={attributeName}
                                    >
                                        {attributeName}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {removedData && removedData.length > 0 ? (
                                removedData.map((product, index) => (
                                    <tr key={product._id || index}>
                                        <td
                                            style={{
                                                width: "50px",
                                                minWidth: "50px",
                                                maxWidth: "50px",
                                                padding: "12px",
                                                textAlign: "center",
                                                position: "sticky",
                                                left: "0",
                                                backgroundColor: "#fff",
                                                zIndex: "10"
                                            }}
                                        >
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                style={{ width: "18px", height: "18px" }}
                                                checked={isProductSelected(product._id)}
                                                onChange={() => handleProductSelect(product._id)}
                                                title={`Select ${product.displayName || product.modelNumber}`}
                                            />
                                        </td>
                                        <td
                                            style={{
                                                width: "300px",
                                                minWidth: "300px",
                                                maxWidth: "300px",
                                                padding: "12px",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                position: "sticky",
                                                left: "50px",
                                                backgroundColor: "#fff",
                                                zIndex: "10"
                                            }}
                                        >
                                            <i
                                                className="fas fa-edit text-primary "
                                                style={{ cursor: "pointer", fontSize: "14px" }}
                                                title="Edit Product"
                                                onClick={() => handleEditProduct(product._id)}
                                            ></i>
                                            <span style={{ fontWeight: "500" }}>
                                                {product.displayName || product.modelNumber || 'N/A'}
                                            </span>
                                        </td>
                                        {allAttributes.map((attributeName, attrIndex) => (
                                            <td
                                                key={`${product._id}-${attrIndex}`}
                                                style={{
                                                    width: "180px",
                                                    minWidth: "180px",
                                                    maxWidth: "180px",
                                                    padding: "12px",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis"
                                                }}
                                                title={getAttributeValue(product, attributeName)}
                                            >
                                                {getAttributeValue(product, attributeName)}
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={2 + allAttributes.length} style={{ textAlign: "center", padding: "20px" }}>
                                        No removed products found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default RemoveProduct;